import Vue from 'vue'
import Vuex from 'vuex'
import Base64 from 'js-base64'
import Bus from './assets/js/bus'
let base = Base64.Base64

Vue.use(Vuex)
Vue.config.devtools = true
export default new Vuex.Store({
  state: {
    mainContainerHeight: 0,
    user: '',
    pwd: '',
    userId: '',
    customerServiceId: '',
    customerNimToken: '',
    customerNimAccid: '',
    guideNim: null, // 人工导医
    appkey: '71d314ba4d301b42167d460a49ced993',
    screenWidth: 1920,
    screenSize: 'l',
    waitMore: false, // 是否有用户进入队列
    onlineNimList: [], // 聊天中的用户新增信息nimId集合
    onlineMore: false, // 是否有聊天中的用户发来信息
    size: '',
    screenWidthhhh: '',
    patientId: ''
  },
  mutations: {
    PatientId (state, value) {
      state.patientId = value
    },
    screenHeightttt (state, value) {
      if (value < 700) {
        state.size = 'small'
      } else {
        state.size = 'large'
      }
    },
    screenWidthhhhh (state, num) { // 屏幕尺寸小于968为s，其他为l
      if (num <= 1400) state.screenWidthhhh = 'small'
      if (num > 1400) state.screenWidthhhh = 'large'
    },
    setScreenWidth (state, num) { // 屏幕尺寸小于968为s，其他为l
      if (num <= 968) state.screenSize = 's'
      if (num > 968) state.screenSize = 'l'
      state.screenWidth = num
    },

    setMainContainerHeight (state, num) {
      // console.log(num);
      state.mainContainerHeight = num
    },
    getMsgFromSession (state, arr) {
      console.log(arr)
      arr.map((item) => {
        if (sessionStorage.getItem(base.encode(item))) state[item] = base.decode(sessionStorage.getItem(base.encode(item)))
      })
    },
    setSession (state, obj) {
      for (let i in obj) {
        sessionStorage.setItem(base.encode(i), base.encode(obj[i]))
      }
    },
    nimDisconnect (state) {
      state.guideNim.disconnect()
      state.guideNim = null
    },
    changeWaitMore (state, bool) {
      console.log(bool)
      state.waitMore = bool
    },
    changeOnlineMore (state, bool) {
      console.log(bool)
      state.onlineMore = bool
    },
    pushOnlineList (state, str) {
      let newStr = state.onlineNimList.join(',')
      if (newStr.indexOf(str) === -1) state.onlineNimList.push(str)
    },
    removeNimListItem (state, str) {
      let targetIndex = -1
      state.onlineNimList.forEach((item, index) => {
        if (item === str) targetIndex = index
      })
      if (targetIndex > -1) state.onlineNimList.splice(targetIndex, 1)
    },
    initNim (state) {
      state.guideNim = new NIM({
        // 初始化SDK
        appKey: state.appkey,
        account: state.customerNimAccid,
        token: state.customerNimToken,
        onmsg: onMsg
      })
      function onMsg (msg) {
        Bus.$emit('onmsg', msg)
      }
      // console.log(msg)
      // if(msg.from == _this.activeUserMsg.nimAccid){
      //     _this.isInit = false;
      //     _this.parse(msg);
      // }else{
      //     let index = -1;
      //     _this.onlineList.forEach((item,i)=>{
      //         if(item.nimAccid == msg.from) index = i;
      //     })
      //     if(index>-1){
      //         try {
      //             var obj = JSON.parse(msg.text);
      //             if(obj.msgType == 'custom_msg_type_chat_begin'){
      //                 return;
      //             }
      //         }catch {
      //             _this.$set(_this.onlineList[index],"isBusy",true)
      //         }
      //     }else{
      //         try{
      //             var obj = JSON.parse(msg.text);
      //             if(obj.msgType == 'custom_msg_type_chat_begin'){
      //                 console.log(111)
      //                 _this.waitListNeedRefresh = true;
      //             }
      //         }catch {}
      //     }
      // }
      // }
    }
  },
  actions: {
    onMsg (msg) {
      console.log(msg)
      return msg
    },
    patientId (context, value) {
      context.commit('PatientId', value)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js